'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M5.608 3a.32.32 0 0 1 .321.321v2.37h14.749c.178 0 .322.144.322.322v14.665a.322.322 0 0 1-.322.322H5.608a2.61 2.61 0 0 1-2.606-2.557C3 18.426 3 18.407 3 18.39V5.61C3 4.172 4.17 3 5.608 3Zm14.749 3.334H5.929v9.767a.32.32 0 0 1-.321.322 1.968 1.968 0 0 0 0 3.934h14.749V6.334Zm-1.006 10.971v.643h-7.688v1.402h-.643v-1.723c0-.178.144-.322.322-.322h8.009Zm-10.285-4.03c.176 0 .32.144.32.321v5.754h-.643v-5.432H6.956v-.643h2.11Zm-3.78-9.604A1.965 1.965 0 0 0 3.643 5.61v11.063c.411-.471.99-.792 1.643-.874Zm6.377 3.67v7.688h7.688v.643h-8.01a.321.321 0 0 1-.32-.321V7.34h.642Zm-2.277 0v3.98a.32.32 0 0 1-.321.32H6.957v-.643h1.787V7.34h.642Z",
    fill: "#3F3E4B"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M19.137 7.34c.118 0 .214.097.214.215v6.26a.214.214 0 0 1-.214.214h-6.26a.214.214 0 0 1-.214-.214v-6.26c0-.118.096-.214.215-.214Zm-.428.644h-5.402v5.402h5.402V7.984Z",
    fill: "currentColor"
  })));
});
var FwSet0Plot1000 = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0Plot1000 = FwSet0Plot1000;